import { IUserResponse } from "@/features/admins/types";
import { TMeta, TUserParamsType } from "@/features/organizations/types";
import MyAxios from "@/utilize/MyAxios";
import { useQuery } from "@tanstack/react-query";
import { TQueryOptions } from "@/@types/axios";

const useGetUsers = (params: TUserParamsType, options: TQueryOptions = {}) => {
  return useQuery({
    queryKey: ["users", params],
    queryFn: () =>
      MyAxios.get<{ items: IUserResponse[]; meta: TMeta }>("/users", {
        params: { ...params, orderBy: params.orderBy?.toLocaleUpperCase() },
      }),
    ...options,
  });
};

export default useGetUsers;
